import React, {useState} from 'react';
import { Helmet } from 'react-helmet';
// import {Redirect} from "react-router-dom";
import Steps from '../../utils/steps/Steps';
import Modal from '../../utils/modal/Modal';
import NewProjectCompetitors from './comp/NewProjectCompetitors';
import NewProjectDomain from './comp/NewProjectDomain';
import NewProjectGauth from './comp/NewProjectGauth';
import NewProjectKeywords, { ImportType } from './comp/NewProjectKeywords';
import NewProjectLocation from './comp/NewProjectLocation';
import NewProjectSummary from './comp/NewProjectSummary';
import PlanSelector from './comp/PlanSelector';
import "./NewProject.scss";
import LoaderInfinity from '../../utils/loader/LoaderInfinity';
import { ProjectPlan } from '../../enums/ProjectPlan';
import { instanceOfIManualmState } from './comp/KeywordsManual';
import Container from '../../utils/container/Container';
import Row from '../../utils/row/Row';
import Col from '../../utils/column/Col';
import Card from '../../utils/card/Card';
import Button from '../../utils/button/Button';
import stylesGrid from "../../style/Grid.module.scss";
import { IProject } from '../../interfaces/IProject';
import { createProject, importKeywordsCollabim, importKeywordsFile, importKeywordsManual } from './NewProjectHandler';
import { IProjectKeyword } from '../../interfaces/IProjectKeyword';
import Menu from '../../layout/menu/Menu';
import Icon from '../../utils/icon/Icon';
import { IconType } from '../../enums/IconType';
import classNames from 'classnames';

const NewProject  = () => {

    const [step, setStep] = useState<number>(0);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [redirect, setRedirect] = useState<string | null>(null);
    const [err, setErr] = useState<string>("");

    const [plan, setPlan] = useState<ProjectPlan>(ProjectPlan.PRO);
    const [checkPeriodYearly, setCheckPeriodYearly] = useState<boolean>(true);

    const [name, setName] = useState<string>("");
    const [domain, setDomain] = useState<string>("");

    // TODO:
    const [location, setLocation] = useState<string>("cze");
    const [locationScope, setLocationScope] = useState<string>("country");

    const [competitors, setCompetitors] = useState<Array<string>>([]);
    const [keywordsMethod, setKeywordsMethod] = useState<ImportType>(ImportType.COLLABIM);
    const [keywordsData, setKeywordsData] = useState<any>(null)

    const [gtoken, setGtoken] = useState<string|null>(null);
    const [gdomain, setGdomain] = useState<string|null>(null);

    const [modalActive, setModalActive] = useState<boolean>(false);

    function createProjectLocal() : void{
        setIsLoading(true);
        createProject({
            name: name,
            domain: (gdomain === null ? domain : gdomain),
            location: location,
            googleToken: gtoken,
            competitors: competitors,
            projectPricePlan: plan
        }).then((resp:IProject)=>{
            switch (keywordsMethod) {
                case ImportType.COLLABIM:
                    importCollabim(resp.projectId);
                    break;
                case ImportType.FILE:
                    importFile(resp.projectId);
                    break;
                case ImportType.MANUAL:
                    importManual(resp.projectId);
                    break;
                default:
                    break;
            }
        }).catch(error=>{
            setIsLoading(false);
            console.error(error);
            setErr("Založení projektu se nezdařilo, zkuste to prosím později.");
        })
    }

    function importManual(projectId: string){
        try {
            const keywordsMinified = keywordsData.value.replaceAll(", ", ",");
            const keywordsArr : Array<string> = keywordsMinified.split(",");
            importKeywordsManual(projectId, keywordsArr).then((resp:Array<IProjectKeyword>)=>{
                setIsLoading(false);
                setRedirect(projectId.replaceAll("/", ""));
            })
        } catch (error) {
            console.error(error);
            setIsLoading(false);
            setErr("Import klíčových slov se nezdařil, zkuste to prosím později v nastavení projektu.");
        }
    }
    function importCollabim(projectId: string){
        try {
            importKeywordsCollabim(projectId, keywordsData.apiKey, keywordsData.projectId).then((resp:Array<IProjectKeyword>)=>{
                setIsLoading(false);
                setRedirect(projectId.replaceAll("/", ""));
            })
        } catch (error) {
            console.error(error);
            setIsLoading(false);
            setErr("Import klíčových slov se nezdařil, zkuste to prosím později v nastavení projektu.");
        }
    }
    function importFile(projectId: string):void{
        try {
            importKeywordsFile(projectId, keywordsData.name).then((resp:Array<IProjectKeyword>)=>{
                setIsLoading(false);
                setRedirect(projectId.replaceAll("/", ""));
            })
        } catch (error) {
            console.error(error);
            setIsLoading(false);
            setErr("Import klíčových slov se nezdařil, zkuste to prosím později v nastavení projektu.");
        }
    }
    // console.log(gtoken);
    return(
        <div className="main-view">
            <Menu
                notWide
            />
            <div id={"main.project-new"} className={"main main-wide main-wide-centered new-projects-main"} key={"main.project-new"}>
                {step === 0 ? (
                    <Container>
                        <Row>
                            <Col width={12}>
                                <PlanSelector
                                    className="plan-selector-wide"
                                    plan={plan}
                                    setPlan={setPlan}
                                    period={checkPeriodYearly}
                                    setPeriod={setCheckPeriodYearly}
                                />
                            </Col>
                        </Row>
                        <Row
                            isGrid={false}
                            offset='normal'
                            className='plan-selector-btn'
                        >
                            <Button
                                onClick={()=>setStep(1)}
                                design='cta'
                            >
                                Založit projekt
                            </Button>
                        </Row>
                    </Container>
                ):(<>
                    <Row>
                        <Col width={9}>
                            <Card padding='none' className='new-project-maincard'>
                                {/* jednotlivé obrazovky */}
                                {step===1?<NewProjectDomain
                                    domain={domain}
                                    setDomain={setDomain}
                                    name={name}
                                    setName={setName}
                                    />:null}
                                {step===2?<NewProjectLocation
                                    domain={domain}
                                    location={location}
                                    locationScope={locationScope}
                                    updateLocation={setLocation}
                                    updateLocationScope={setLocationScope}
                                    defaultValue="cze"
                                    />:null}
                                {step===3?<NewProjectCompetitors
                                    domain={domain}
                                    competitors={competitors}
                                    updateCompetitors={setCompetitors}
                                    plan={plan}
                                    />:null}
                                {step===4?<NewProjectKeywords
                                    importType={keywordsMethod}
                                    setImportType={(method)=>{
                                        setKeywordsMethod(method);
                                        setKeywordsData(null)
                                    }}
                                    data={keywordsData}
                                    setData={setKeywordsData}
                                    plan={plan}
                                    />:null}
                                {step===5?<NewProjectGauth
                                    setToken={setGtoken}
                                    setGdomain={setGdomain}
                                    />:null}
                                {step===6?<NewProjectSummary
                                    isTokenSet={(gdomain!==null)}
                                    gAuthReturn={()=>setStep(5)}
                                    domain={domain}
                                    name={name}
                                    plan={plan}
                                    competitorsCount={competitors.length}
                                    keywordsCount={(keywordsMethod === ImportType.MANUAL && instanceOfIManualmState(keywordsData)) ? keywordsData.count : undefined}
                                    />:null}
                                {/* konec jednotlivých */}
                            </Card>
                        </Col>
                        <Col width={3}>
                            <Card padding='narrow' className='selected-plan'>
                                <p>Vybraný tarif</p>
                                <p className="bold">{ProjectPlan[plan].toLocaleLowerCase()}</p>
                                <Button
                                    design='icon-hover'
                                    onClick={()=>setModalActive(!modalActive)}
                                >
                                    <Icon icon={IconType.settings} alt="select" />
                                    <Icon icon={IconType.settingsActive} alt="select" />
                                </Button>
                            </Card>
                            <Card padding='narrow' className={stylesGrid.offset__mid}>
                                <Steps
                                    list={["Název projektu", "Oblast", "Konkurence", "Klíčová slova", "Search Console", "Shrnutí"]}
                                    current={step-1}
                                    skipped={[
                                        (domain&&name?9999:0),
                                        (location?9999:1),
                                        (competitors.length>0?9999:2),
                                        (keywordsData!==null?999999:3),
                                        // (keywords.length>0?9999:3),
                                        (gdomain===null?4:99999),
                                    ]}
                                    goTo={(i)=>setStep(i+1)}
                                />
                            </Card>
                        </Col>
                    </Row>
                    <Row offset='normal' isGrid={false} className={classNames(`new-project-navigate`, step === 6 && "single-button")}>
                        {step===6?
                            <Col><div className="text-center project-sum">
                                <Button design='cta' onClick={createProjectLocal}>Založit projekt</Button>
                                <img className="illustration" src={process.env.PUBLIC_URL+"/imgs/illustrations/ProjectNewSummary.svg"} alt="illustration" />
                            </div></Col>:
                            <>
                                {/* <Col> */}
                                    <Button disabled={(step<1)} onClick={()=>setStep(step - 1)} design='tertiary'>O krok zpět</Button>
                                {/* </Col>
                                <Col> */}
                                    <div style={{textAlign: "right"}}>
                                        {step===5&&gdomain===null?
                                        <Button
                                            onClick={()=>setStep(step+1)}
                                            design='secondary'
                                        >
                                            Přeskočit
                                        </Button>
                                        :
                                        <Button
                                            onClick={()=>setStep(step+1)}
                                        >
                                            Další krok
                                        </Button>}
                                    </div>
                                {/* </Col> */}
                            </>
                        }
                    </Row>
                </>)}
                <Modal isDisabled={!modalActive} dismiss={() => setModalActive(false)}>
                    <PlanSelector
                        className="col-12"
                        plan={plan}
                        setPlan={setPlan}
                        setPeriod={setCheckPeriodYearly}
                        period={checkPeriodYearly}
                    />
                </Modal>
                <Modal
                    isDisabled={err===""}
                    dismiss={()=>setErr("")}
                    heading="Chyba"
                    content={err}
                />
                    {isLoading?<LoaderInfinity />:null}
            </div>
        </div>
        // <div className="main-view">
        //     <div className="menu menu-hidden">
        //         <Menu />
        //     </div>
        //     <div id="main.new-project" className="main main-wide">
        //         <Helmet>
        //             <title>Založení projektu | KeywordEater.cz</title>
        //             <meta name="description" content="Keyword Eater" />
        //         </Helmet>
        //         {step===0?
        //         <div className="main-content new-projects-main">
                    // <Container>
                    //     <Row>
                    //         <Col width={12}>
                    //             <PlanSelector
                    //                 className="plan-selector-wide"
                    //                 plan={plan}
                    //                 setPlan={setPlan}
                    //                 period={checkPeriodYearly}
                    //                 setPeriod={setCheckPeriodYearly}
                    //             />
                    //         </Col>
                    //     </Row>
                    //     <Row offset='normal'>
                    //         <Col width={12} className='text-center'>
                    //             <Button
                    //                 onClick={()=>setStep(1)}
                    //             >
                    //                 Založit projekt
                    //             </Button>
                    //         </Col>
                    //     </Row>
                    // </Container>
        //         </div>
        //         :<div className="main-content main-content-wide new-projects-main">
                    // <Row>
                    //     <Col width={9}>
                    //         <Card padding='none' className='new-project-maincard'>
                    //             {/* jednotlivé obrazovky */}
                    //             {step===1?<NewProjectDomain
                    //                 domain={domain}
                    //                 setDomain={setDomain}
                    //                 name={name}
                    //                 setName={setName}
                    //                 />:null}
                    //             {step===2?<NewProjectLocation
                    //                 domain={domain}
                    //                 location={location}
                    //                 locationScope={locationScope}
                    //                 updateLocation={setLocation}
                    //                 updateLocationScope={setLocationScope}
                    //                 defaultValue="Česká Republika"
                    //                 />:null}
                    //             {step===3?<NewProjectCompetitors
                    //                 domain={domain}
                    //                 competitors={competitors}
                    //                 updateCompetitors={setCompetitors}
                    //                 plan={plan}
                    //                 />:null}
                    //             {step===4?<NewProjectKeywords
                    //                 importType={keywordsMethod}
                    //                 setImportType={(method)=>{
                    //                     setKeywordsMethod(method);
                    //                     setKeywordsData(null)
                    //                 }}
                    //                 data={keywordsData}
                    //                 setData={setKeywordsData}
                    //                 plan={plan}
                    //                 />:null}
                    //             {step===5?<NewProjectGauth
                    //                 setToken={setGtoken}
                    //                 setGdomain={setGdomain}
                    //                 />:null}
                    //             {step===6?<NewProjectSummary
                    //                 isTokenSet={(gdomain!==null)}
                    //                 gAuthReturn={()=>setStep(5)}
                    //                 domain={domain}
                    //                 name={name}
                    //                 plan={plan}
                    //                 competitorsCount={competitors.length}
                    //                 keywordsCount={(keywordsMethod === ImportType.MANUAL && instanceOfIManualmState(keywordsData)) ? keywordsData.count : undefined}
                    //                 />:null}
                    //             {/* konec jednotlivých */}
                    //         </Card>
                    //     </Col>
                    //     <Col width={3}>
                    //         <Card padding='narrow' className='selected-plan'>
                    //             <p>Vybraný tarif</p>
                    //             <p className="bold">{ProjectPlan[plan].toLocaleLowerCase()}</p>
                    //             <button onClick={()=>setModalActive(!modalActive)} className="btn btn-link plan-setup">
                    //                 <img className="plan-setup-img" src={process.env.PUBLIC_URL+"/svgs/outline/Settings.svg"} alt="plan setup" />
                    //                 <img className="plan-setup-img" src={process.env.PUBLIC_URL+"/svgs/bold/Settings.svg"} alt="plan setup" />
                    //             </button>
                    //         </Card>
                    //         <Card padding='narrow' className={stylesGrid.offset__mid}>
                    //             <Steps
                    //                 list={["Název projektu", "Oblast", "Konkurence", "Klíčová slova", "Search Console", "Shrnutí"]}
                    //                 current={step-1}
                    //                 skipped={[
                    //                     (domain&&name?9999:0),
                    //                     (location?9999:1),
                    //                     (competitors.length>0?9999:2),
                    //                     (keywordsData!==null?999999:3),
                    //                     // (keywords.length>0?9999:3),
                    //                     (gdomain===null?4:99999),
                    //                 ]}
                    //                 goTo={(i)=>setStep(i+1)}
                    //             />
                    //         </Card>
                    //     </Col>
                    // </Row>
                    // <Row offset='normal'>
                    //     {step===6?
                    //         <Col width={12}><div className="text-center project-sum">
                    //             <Button design='cta' onClick={createProjectLocal}>Založit projekt</Button>
                    //             <img className="illustration" src={process.env.PUBLIC_URL+"/imgs/illustrations/ProjectNewSummary.svg"} alt="illustration" />
                    //         </div></Col>:
                    //         <>
                    //             <Col width={6}>
                    //                 <Button disabled={(step<1)} onClick={()=>setStep(step - 1)} design='tertiary'>O krok zpět</Button>
                    //             </Col>
                    //             <Col width={6}>
                    //                 <div style={{textAlign: "right"}}>
                    //                     {step===5&&gdomain===null?
                    //                     <Button
                    //                         onClick={()=>setStep(step+1)}
                    //                         design='secondary'
                    //                     >
                    //                         Přeskočit
                    //                     </Button>
                    //                     :
                    //                     <Button
                    //                         onClick={()=>setStep(step+1)}
                    //                     >
                    //                         Další krok
                    //                     </Button>}
                    //                 </div>
                    //             </Col>
                    //         </>
                    //     }
                    // </Row>
        //         </div>}
                // <Modal isDisabled={!modalActive} dismiss={() => setModalActive(false)}>
                //     <PlanSelector
                //         className="col-12"
                //         plan={plan}
                //         setPlan={setPlan}
                //         setPeriod={setCheckPeriodYearly}
                //         period={checkPeriodYearly}
                //     />
                // </Modal>
                // <Modal
                //     isDisabled={err===""}
                //     dismiss={()=>setErr("")}
                //     heading="Chyba"
                //     content={err}
                // />
                //     {isLoading?<LoaderInfinity />:null}
        //     </div>
        //     {/* {redirect!==null?<Redirect to={process.env.REACT_APP_BASEPATH+"/projects/"+redirect} />:null} */}
        // </div>
    );
}
export default NewProject;